import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { Loader } from '@components/Loader';
import { RoutesConfiguration } from '@components/RouterOutlet';
import { permissionsRoles } from '@config/permissions';

import { MenuRoutePaths } from '../routesPaths';

const Menu = withSuspenseLazy(
  () => import('./MenuPage'),
  Loader,
);

export const MenuRouteConfig: RoutesConfiguration = [
  {
    path: MenuRoutePaths.menuRoot,
    component: Menu,
    permittedRoles: permissionsRoles.menu,
  },
];
